export default "__VITE_ASSET__S_P07j$S__"